export default __webpack_public_path__ + "static/media/repubblica.13477260.png";